export default __webpack_public_path__ + "static/media/grupa-iepurasilor.f1458684.png";